module.exports = __webpack_public_path__ + "708d2ff75b0ca27812c2cdb2806b00ea.MP3";